"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deepEquals = deepEquals;
exports.clone = clone;
exports.smartCompare = exports.sorter = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _immutable = require("immutable");

function defaultToEmptyObject(obj) {
  return obj === null || obj === undefined ? {} : obj;
}

function deepEquals(initialValues, newValues) {
  return (0, _immutable.fromJS)(defaultToEmptyObject(initialValues)).equals((0, _immutable.fromJS)(defaultToEmptyObject(newValues)));
}

function clone(data) {
  return (0, _immutable.fromJS)(data).toJS();
}

function get(name, target) {
  return name in target ? target[name] : null;
}

var sorter = function sorter(propName) {
  return function (x, y) {
    var values = {
      x: get(propName, x),
      y: get(propName, y)
    };

    if (typeof values.x === 'string' && typeof values.y === 'string') {
      return values.x < values.y ? -1 : values.x > values.y ? 1 : 0;
    } else if (typeof values.x === 'number' && typeof values.y === 'number') {
      return values.x - values.y;
    } else {
      return 0;
    }
  };
};

exports.sorter = sorter;

var smartCompare = function smartCompare(a, b) {
  if (a && (0, _typeof2["default"])(a) === 'object') {
    if (b && (0, _typeof2["default"])(b) === 'object') {
      return deepEquals(a, b);
    }

    return false;
  }

  return a === b;
};

exports.smartCompare = smartCompare;
//# sourceMappingURL=objectHelpers.js.map